const TIME_ZONE_SUFFIX = /(?:Z|[+-]\d{2}(?::?\d{2})?)$/i;

export function parseUtcDate(value: string): Date {
  return new Date(TIME_ZONE_SUFFIX.test(value) ? value : `${value}Z`);
}
